import type { RealtimeBinding } from '@/shared/api';
import { qk } from '@/shared/api';
import { lazyComponent, type OverlayDef } from '@/shared/lib';
import type { CreateItem } from '@/widgets/app-shell';

/** Thành phần lớp phủ nạp khi mở (chunk riêng; OverlayHost nạp trước lúc rảnh). */
const BookingOverlay = lazyComponent(() => import('./ui/overlays'), (x) => x.BookingOverlay, 'BookingOverlay');
const UnitOverlay = lazyComponent(() => import('./ui/overlays'), (x) => x.UnitOverlay, 'UnitOverlay');

/** Chốt căn không có mục "Tạo mới" (căn được tìm qua nguồn "Căn / sản phẩm" của Nguồn hàng). */
export const createItems: CreateItem[] = [];

/** Drawer căn (+ forCustomer: chọn sẵn "Giữ cho khách") và phiếu chốt căn. */
export const overlays: OverlayDef[] = [
  { key: 'unit', module: 'booking', companions: ['forCustomer'], layer: 'drawer', component: UnitOverlay },
  { key: 'booking', module: 'booking', layer: 'modal', component: BookingOverlay },
];

/**
 * booking.units (gợi ý { ids }) ⇒ tải lại qua API mọi khoá 'booking' (bảng hàng đang xem, căn của tôi, diễn biến, số trống
 * từng dự án và qk.booking.unit(id) của drawer đang mở — cùng tiền tố nên không khai báo riêng để tránh gọi trùng).
 */
export const realtime: RealtimeBinding[] = [{ topic: 'booking.units', module: 'booking', keys: () => [qk.booking.all], throttleMs: 300 }];
